// extracted by mini-css-extract-plugin
export default {"resetFiltersButton":"_1aLZt0dl"};